Namespace 'Customer.Filters'

class Customer.Filters.SubTypeTranslator
  constructor: ->
    @translations = {
      'facebook': I18n.t('customer.dashboard.conversations.details.type_indicators.facebook'),
      'fb-post': 'Fb Post',
      'fb-comment': 'Fb Comment',
      'fb-message': 'Fb Message',
      'fb-user': 'Fb User',
      'twitter': I18n.t('customer.dashboard.conversations.details.type_indicators.twitter'),
      'tw-user': 'Tw User',
      'tweet': 'Tw Tweet',
      'retweet': 'Tw Retweet',
      'quote': 'Tw Quote',
      'direct-message': 'Tw Direct Message',
      'instagram': I18n.t('customer.dashboard.conversations.details.type_indicators.instagram'),
      'ig-user': 'Ig User',
      'ig-comment': 'Ig Comment',
      'ig-video': 'Ig Video',
      'ig-image': 'Ig Image',
      'ig-message': 'Ig Message',
      'ig-story': 'Ig Story',
      'email': I18n.t('customer.dashboard.conversations.details.type_indicators.email'),
      'email-user': 'e-mail user',
      'youtube': I18n.t('customer.dashboard.conversations.details.type_indicators.youtube'),
      'yt-comment': 'YouTube comment',
      'yt-video': 'YouTube video',
      'yt-user': 'YouTube user',
      'webchat': I18n.t('customer.dashboard.conversations.details.type_indicators.webchat'),
      'whatsapp': I18n.t('customer.dashboard.conversations.details.type_indicators.whatsapp'),
      'linkedin': 'Linkedin',
      'li-comment': 'Linkedin comment',
      'li-post': 'Linkedin post',
      'li-user': 'Linkedin user',
      'apple_app_store': 'Apple App Store',
      'apple_app_store_review_comment': 'App Store Review',
      'google_play': 'Google Play',
      'gp_review_comment': 'Google Play Review',
      'google_my_business': 'Google My Business',
      'google-my-business-review': 'Google My Business Review',
      'google-my-business-reply': 'Google My Business Reply',
      'tiktok-ad': 'TikTok Ad',
      'tiktok-comment': 'TikTok Comment',
      'tiktok-post': 'TikTok Post'
      'tiktok-user': 'TikTok User'
    }

  getTranslation: (name) ->
    @translations[name] || name

  getSubtypeOnlyTranslation: (name) ->
    I18n.t("monitoring.arrival_alerts.subtypes.only_subtypes.#{name}", {defaultValue: name})

  getSubtypeTranslation: (name, {locale} = {}) ->
    I18n.t("monitoring.arrival_alerts.subtypes.#{name}", {defaultValue: name, locale})
